import {
  FETCH_LANGUAGE_REQUEST,
  FETCH_LANGUAGE_SUCCESS,
  FETCH_LANGUAGE_FAILURE,
  SET_LANGUAGE_LOADED,
  SET_LANGUAGE,
} from "../actions/languageActions";

const initialState = {
  language: "",
  isLanguageLoaded: false,
  loading: false,
  error: null,
};

const languageReducer = (state = initialState, action) => {  
  switch (action.type) {
    case FETCH_LANGUAGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_LANGUAGE_SUCCESS:
      return {
        ...state,
        language: action.payload,
        loading: false,
        error: null,
      };
    case FETCH_LANGUAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case SET_LANGUAGE_LOADED:
      return {
        ...state,
        isLanguageLoaded: action.payload,
      };
    case SET_LANGUAGE:
      return {
        ...state,
        language: action.payload,
      };
    default:
      return state;
  }
};

export default languageReducer;

